import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { HelmetProvider } from "react-helmet-async";

import "./index.css";
import App from "./App";
import theme from "./design/theme";

// The Redux store is gone: its only real consumer was the blog list, which now
// reads from data/journal.js, and its auth reducer was never dispatched to.
// Admin auth runs on the JWT in localStorage — see Components/ProtectedRoute.jsx.

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);
